import './MeterBarChartThresholdIntervals.css';
export var thresholdIntervals = '_n2jd1m0-3-12-1';